import { useState } from 'react';
import { EmptyState, PageHeader, Select } from '@/shared/components';
import { useObjectScope } from '@/shared/object-scope';
import { ObjectParkingSection } from './ObjectParkingSection';

export function ParkingPage() {
  const { groups, groupId, isLoading } = useObjectScope();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const selectedGroup =
    groups.find((group) => group.id === (selectedId ?? groupId)) ?? groups[0] ?? null;

  return (
    <>
      <PageHeader
        eyebrow="Objektweite Ressourcen"
        title="Ihre"
        titleAccent="Parkplätze"
        description="Stellplätze werden einmal pro Objekt angelegt und gezielt Apartments zugewiesen. Wer wann wo steht, zeigt der Belegungs-Kalender im Stellplatz-Modus."
      />
      {!isLoading && groups.length === 0 ? (
        <EmptyState
          icon="Pin"
          title="Noch keine Objekte"
          description="Beim ersten Apartment entsteht automatisch ein Objekt. Danach können Sie hier Parkplätze anlegen."
        />
      ) : selectedGroup ? (
        <div className="space-y-6">
          <div className="border-line/60 bg-card max-w-xl rounded-lg border p-5">
            <label
              htmlFor="parking-object"
              className="text-ink-soft mb-2 block text-xs font-semibold uppercase tracking-[0.12em]"
            >
              Objekt für Parkplatzverwaltung
            </label>
            <Select
              id="parking-object"
              value={selectedGroup.id}
              onChange={(event) => setSelectedId(event.target.value)}
            >
              {groups.map((group) => (
                <option key={group.id} value={group.id}>
                  {group.name} · {group.address.city}
                </option>
              ))}
            </Select>
          </div>
          <ObjectParkingSection group={selectedGroup} />
        </div>
      ) : null}
    </>
  );
}
